import { format } from "date-fns";

import { CustomDateRangeFilterId, Filter, IDateRangeFilter } from "constants/filters";

import { dateRangeFilterConfig } from "../date-range-filter";
import { getNumericValue, getTimeFrame } from "../date-range-filter/DateRangeFilter";
import { IFilterConfig, IFilterLabelValue } from "../interfaces";

const labelsMap = {
  [CustomDateRangeFilterId.Today]: "Last activity today",
  [CustomDateRangeFilterId.Yesterday]: "Last activity yesterday",
  [CustomDateRangeFilterId.Last7Days]: "Last activity in last 7 days",
  [CustomDateRangeFilterId.LastMonth]: "Last activity last month",
};

export const lastActivityDateRangeFilterConfig: IFilterConfig = {
  ...dateRangeFilterConfig,
  title: "Last activity",
  getFilterLabelValues: (filterValues: IDateRangeFilter): IFilterLabelValue[] => {
    if (filterValues === null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    let label =
      // @ts-expect-error TS(7053)
      labelsMap[filterValues.id] ||
      // @ts-expect-error TS(2345)
      `Last activity ${format(filterValues.from, "YYYY-MM-DD")} – ${format(filterValues.to, "YYYY-MM-DD")}`;

    if (filterValues.from && filterValues.id === CustomDateRangeFilterId.CustomTime) {
      // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      label = `Last activity in last ${getNumericValue(parseInt(filterValues.from.toString(), 10) - 1)} ${getTimeFrame(
        filterValues.from
      )}`;
    }

    return [
      {
        key: Filter.LastActivityDateRange,
        label,
      },
    ];
  },
};
